
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { AutoSaleRowSetting } from "@/models/auto-sale-row-setting";
import { CompanyDossierService, CompanyService } from "@/services";
import { AutoSaleRowSettingsService } from "@/services/auto-sale-row-settings-service";
import AppDossierAutoSaleRowSettingEdit from "@/components/dossier/DossierAutoSaleRowSettingEdit.vue";
import AppDossierAutoSaleRowSettingEditConditions from "@/components/dossier/DossierAutoSaleRowSettingEditConditions.vue";
import { SaleType } from "@/models/sale-type";

export default Vue.extend({
	data(){
		return {
			company: new Company(),
			dossier: new Dossier(),
			setting: new AutoSaleRowSetting(),
			ready: false,
			saving: false,
			valid: false,
			conditionsModalOpen: false,
			saleTypes: [] as SaleType[]
		};
	},
	methods: {
		async save(){
			if (!this.valid) return;
			if (this.saving) return;
			this.saving = true;
			try{
				if (this.setting.ID) {
					this.setting = await AutoSaleRowSettingsService.editSetting(this.dossier.id, this.setting);
				}else{
					this.setting = await AutoSaleRowSettingsService.createSetting(this.dossier.id, this.setting);
				}
				this.$wf.notify("Instellingen opgeslagen", "success", 3000, "check");
			}catch(err){

			}finally{
				this.saving = false;
			}
		},
		goToDossier(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.dossier.id}/edit`);
		},
		editConditions(){
			this.conditionsModalOpen = true;
		}
	},
	async created(){
		let companyId = parseInt(this.$route.params.companyId);
		let dossierId = parseInt(this.$route.params.dossierId);
		this.company = await CompanyService.getCompany(companyId);
		this.dossier = await CompanyDossierService.getDossier(companyId, dossierId);
		let settingId = parseInt(this.$route.params.settingId || "0");
		if (settingId != 0){
			this.setting = await AutoSaleRowSettingsService.getSetting(this.dossier.id, settingId);
		}
		this.saleTypes = await CompanyDossierService.getSaleTypes(dossierId);
		this.ready = true;
	},
	components: {
		AppDossierAutoSaleRowSettingEdit,
		AppDossierAutoSaleRowSettingEditConditions
	}
});
